import { useGetEstimateInfoMinimalByIdQuery } from '@massilia/queries'
import { createFileRoute, useSearch } from '@tanstack/react-router'
import { z } from 'zod'

import { LoadingSkeleton } from '../reservation/-components/loading-skeleton'
import { ReservationError } from '../reservation/-components/reservation-error'
import { ReservationForm } from '../reservation/-components/reservation-form'

const searchSchema = z.object({
  withInsurance: z.boolean().optional().default(false),
})

export const Route = createFileRoute('/_blue_header/reservation/$estimateResponseId')({
  component: ReservationPage,
  errorComponent: ReservationError,
  validateSearch: searchSchema,
})

export function ReservationPage() {
  const { estimateResponseId } = Route.useParams()
  const { withInsurance } = useSearch({ from: '/_blue_header/reservation/$estimateResponseId' })

  const {
    data: estimateData,
    error,
    isLoading,
  } = useGetEstimateInfoMinimalByIdQuery({
    id: estimateResponseId,
  })

  if (isLoading) {
    return <LoadingSkeleton />
  }

  if (error || !estimateData) {
    return <ReservationError error={error} />
  }

  return (
    <ReservationForm
      estimateData={estimateData}
      estimateResponseId={estimateResponseId}
      withInsurance={withInsurance}
    />
  )
}
